<template>
  <div id="businessLicense">
    <a-form
      ref="step4Ref"
      class="ant-round-form material-business-license-form"
      layout="vertical"
      :model="modelForm"
      :rules="rules"
      @finish="submit"
    >
      <!-- company register date picker -->
      <a-form-item name="bizRegDate" :label="$t('pages_merchant2_012')" :rules="{ required: true }">
        <a-date-picker
          v-model:value="modelForm.bizRegDate"
          size="large"
          allow-clear
          :disabled="modelForm.bizRegDateDisabled"
          :placeholder="$t('pages_merchant2_012')"
          value-format="YYYY-MM-DD"
        />
        <div v-if="!modelForm.bizRegDateDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.bizRegDateMessage }}</span>
        </div>
      </a-form-item>
      <!-- company register date expire date picker -->
      <a-form-item name="bizRegExpDate" :label="$t('pages_merchant2_013')" :rules="{ required: true }">
        <a-date-picker
          v-model:value="modelForm.bizRegExpDate"
          size="large"
          allow-clear
          :disabled="modelForm.bizRegExpDateDisabled"
          :placeholder="$t('pages_merchant2_013')"
          value-format="YYYY-MM-DD"
        />
        <div v-if="!modelForm.bizRegExpDateDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.bizRegExpDateMessage }}</span>
        </div>
      </a-form-item>
      <!-- company register address -->
      <a-form-item name="registrationAddress" :label="$t('pages_merchant2_015')" :rules="{ required: true }">
        <a-input
          v-model:value="modelForm.registrationAddress"
          size="large"
          allow-clear
          :disabled="modelForm.registrationAddressDisabled"
          :placeholder="$t('pages_merchant2_015')"
        />
        <div v-if="!modelForm.registrationAddressDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.registrationAddressMessage }}</span>
        </div>
      </a-form-item>
      <!-- merchantRegistrationType, selection -->
      <a-form-item name="merchantRegistrationType" :label="$t('pages_merchant2_016')" :rules="{ required: true }">
        <a-select
          v-model:value="modelForm.merchantRegistrationType"
          show-search
          size="large"
          option-filter-prop="label"
          :placeholder="$t('pages_merchant2_016')"
          :disabled="modelForm.companyTypeDisabled"
        >
          <a-select-option
            v-for="item in merchantRegistrationTypes"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          >{{ item.name }}</a-select-option>
        </a-select>
        <div v-if="!modelForm.companyTypeDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.companyTypeMessage }}</span>
        </div>
      </a-form-item>
      <!-- 非香港公司的注册证件号/大陆的营业执照证件号/香港公司提供商业登记证(BR)号码 -->
      <a-form-item
        name="bizRegID"
        :label="countryCode === 'HK' ? $t('pages_merchant2_008') : countryCode === 'CN' ? $t('pages_merchant2_008_1') : $t('pages_merchant2_008_2')"
        :rules="{ required: true }"
      >
        <a-input
          v-model:value="modelForm.bizRegID"
          size="large"
          allow-clear
          :disabled="modelForm.bizRegIDDisabled"
          :placeholder="$t('pages_merchant2_008_0')"
        />
        <div v-if="!modelForm.bizRegIDDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.bizRegIDMessage }}</span>
        </div>
      </a-form-item>
      <!-- HK require CI number -->
      <a-form-item
        v-if="countryCode === 'HK'"
        name="ciNumber"
        :label="$t('pages_merchant2_007')"
        :rules="{ required: true }"
      >
        <a-input
          v-model:value="modelForm.ciNumber"
          size="large"
          allow-clear
          :disabled="modelForm.ciNumberDisabled"
          :placeholder="$t('pages_merchant2_007')"
        />
        <div v-if="!modelForm.ciNumberDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.ciNumberMessage }}</span>
        </div>
      </a-form-item>
      <!-- 1年之内是否更换过董事或UBO -->
      <a-form-item name="dirUBOChangeInYear" :label="$t('pages_merchant2_051')" :rules="{ required: true }">
        <a-radio-group
          v-model:value="modelForm.dirUBOChangeInYear"
          :disabled="modelForm.dirUBOChangeInYearDisabled"
        >
          <a-radio value="0">{{ $t('pages_merchant2_051-0') }}</a-radio>
          <a-radio value="1">{{ $t('pages_merchant2_051-1') }}</a-radio>
        </a-radio-group>
        <div v-if="!modelForm.dirUBOChangeInYearDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.dirUBOChangeInYearMessage }}</span>
        </div>
      </a-form-item>
      <a-form-item
        name="bizRegProofPath"
        :label="$t('pages_merchant2_011')"
        :rules="{ required: true }"
      >
        <div class="explain" style="margin-bottom: 24px">
          <span>{{ $t('pages_merchant2_011_0') }}</span>
        </div>
        <upload-auto
          ref="uploadBizRegProofPathRef"
          v-model:file-content="modelForm.bizRegProofPath"
          accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
          type="INVITE"
          list-type="picture"
          back-type="array"
          :disabled="modelForm.bizRegProofPathDisabled"
          :explain="$t('pages_merchant_032')"
          :max-count="5"
        />
        <div v-if="!modelForm.bizRegProofPathDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.bizRegProofPathMessage }}</span>
        </div>
      </a-form-item>
      <a-form-item
        v-if="countryCode === 'HK'"
        name="ciPath"
        :label="$t('pages_merchant2_011_1')"
        :rules="{ required: true }"
      >
        <upload-auto
          ref="uploadCiPathRef"
          v-model:file-content="modelForm.ciPath"
          accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
          type="INVITE"
          list-type="picture"
          back-type="array"
          :disabled="modelForm.ciPathDisabled"
          :explain="$t('pages_merchant2_011')"
          :max-count="5"
        />
        <div v-if="!modelForm.ciPathDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.ciPathMessage }}</span>
        </div>
      </a-form-item>
      <!-- taxNo input for 美国/英国 -->
      <a-form-item
        v-if="['US', 'GB'].includes(countryCode)"
        name="taxNo"
        :label="$t('pages_merchant2_021')"
        :rules="{ required: true }"
      >
        <a-input
          v-model:value="modelForm.taxNo"
          size="large"
          allow-clear
          :disabled="modelForm.taxNoDisabled"
          :placeholder="$t('pages_merchant2_021')"
        />
        <div v-if="!modelForm.taxNoDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.taxNoMessage }}</span>
        </div>
      </a-form-item>

      <!-- hk company requires nnc1Path2 -->
      <a-form-item
        v-if="countryCode === 'HK'"
        name="nnc1Path2"
        :label="$t('pages_merchant2_018')"
        :rules="{ required: true }"
      >
        <upload-auto
          ref="uploadNnc1PathRef"
          v-model:file-content="modelForm.nnc1Path2"
          accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
          type="INVITE"
          list-type="picture"
          back-type="array"
          :disabled="modelForm.nnc1PathDisabled"
          :explain="$t('pages_merchant_032')"
          :max-count="5"
        />
        <div v-if="!modelForm.nnc1PathDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.nnc1PathMessage }}</span>
        </div>
      </a-form-item>
      <!-- 非新加坡、英国、意大利、菲律宾注册的商户必须提供公司章程 -->
      <a-form-item
        v-if="!['CN'].includes(countryCode)"
        name="corpConstPath"
        :label="$t('pages_merchant2_019')"
        :rules="{ required: true }"
      >
        <upload-auto
          ref="uploadCorpConstPathRef"
          v-model:file-content="modelForm.corpConstPath"
          accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
          type="INVITE"
          list-type="picture"
          back-type="array"
          :disabled="modelForm.corpConstPathDisabled"
          :explain="$t('pages_merchant_032')"
          :max-count="5"
        />
        <div v-if="!modelForm.corpConstPathDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.corpConstPathMessage }}</span>
        </div>
      </a-form-item>
      <!-- 股权证明上传 -->
      <a-form-item
        v-if="['PH', 'VG', 'KY'].includes(countryCode)"
        name="shareCerPath"
        :label="$t('pages_merchant2_033')"
        :rules="{ required: true }"
      >
        <div class="explain">{{ $t('pages_merchant2_033_0') }}</div>
        <upload-auto
          ref="uploadShareCerPathRef"
          v-model:file-content="modelForm.shareCerPath"
          accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip,.zip"
          type="INVITE"
          list-type="picture"
          back-type="array"
          :disabled="modelForm.shareCerPathDisabled"
          :explain="$t('pages_merchant_032')"
          :max-count="5"
        />
        <div v-if="!modelForm.shareCerPathDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.shareCerPathMessage }}</span>
        </div>
      </a-form-item>
      <!-- goodstandPath upload for 维京/开曼 -->
      <a-form-item
        v-if="['VG', 'KY'].includes(countryCode)"
        name="goodStandingPath"
        :label="$t('pages_merchant2_020')"
        :rules="{ required: true }"
      >
        <upload-auto
          ref="uploadGoodStandingPathRef"
          v-model:file-content="modelForm.goodStandingPath"
          accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
          type="INVITE"
          list-type="picture"
          back-type="array"
          :disabled="modelForm.goodStandingPathDisabled"
          :explain="$t('pages_merchant_032')"
          :max-count="5"
        />
        <div v-if="!modelForm.goodStandingPathDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.goodStandingPathMessage }}</span>
        </div>
      </a-form-item>
      <!-- hk company and register date over 1 year, requires to upload nar1 -->
      <a-form-item
        v-if="countryCode === 'HK'"
        name="nar1Path2"
        :label="$t('pages_merchant2_017')"
        :rules="{ required: false }"
      >
        <upload-auto
          ref="uploadNar1PathRef"
          v-model:file-content="modelForm.nar1Path2"
          accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
          type="INVITE"
          list-type="picture"
          back-type="array"
          :disabled="modelForm.nar1Path1Disabled"
          :explain="$t('pages_merchant_032')"
          :max-count="5"
        />
        <div v-if="!modelForm.nar1PathDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.nar1PathMessage }}</span>
        </div>
      </a-form-item>
      <!-- 非大陆、香港、美国、意大利、新加坡、菲律宾以及维京和开曼群岛注册的商户必须提供注册申请书 -->
      <a-form-item
        v-if="!['HK', 'CN', 'US', 'IT', 'SG', 'PH', 'VG', 'KY'].includes(countryCode)"
        name="regApplyPath"
        :label="$t('pages_merchant2_014')"
        :rules="{ required: true }"
      >
        <upload-auto
          ref="uploadRegApplyPathRef"
          v-model:file-content="modelForm.regApplyPath"
          accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
          type="INVITE"
          list-type="picture"
          back-type="array"
          :disabled="modelForm.regApplyPathDisabled"
          :explain="$t('pages_merchant_032')"
          :max-count="5"
        />
        <div v-if="!modelForm.regApplyPathDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.regApplyPathMessage }}</span>
        </div>
      </a-form-item>
      <!-- 非香港、大陆、新加坡注册的商户提供代理注册证明书 proxyProfPath -->
      <a-form-item
        v-if="!['HK', 'CN', 'SG'].includes(countryCode)"
        name="proxyProfPath"
        :label="$t('pages_merchant2_022')"
      >
        <upload-auto
          ref="uploadProxyProfPathRef"
          v-model:file-content="modelForm.proxyProfPath"
          accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
          type="INVITE"
          list-type="picture"
          back-type="array"
          :disabled="modelForm.proxyProfPathDisabled"
          :explain="$t('pages_merchant_032')"
          :max-count="5"
        />
        <div v-if="!modelForm.proxyProfPathDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.proxyProfPathMessage }}</span>
        </div>
      </a-form-item>

      <a-form-item
        v-if="!['HK', 'CN', 'SG'].includes(countryCode)"
        name="directIncumPath"
        :label="$t('pages_merchant2_063')"
        :rules="{ required: true }"
      >
        <upload-auto
          ref="uploadDirectIncumPathRef"
          v-model:file-content="modelForm.directIncumPath"
          accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
          type="INVITE"
          list-type="picture"
          back-type="array"
          :disabled="modelForm.directIncumPathDisabled"
          :explain="$t('pages_merchant_032')"
          :max-count="5"
        />
        <div v-if="!modelForm.directIncumPathDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.directIncumPathMessage }}</span>
        </div>
      </a-form-item>
      <!-- PH 需要 sourceFundsPath -->
      <a-form-item
        v-if="countryCode === 'PH'"
        name="sourceFundsPath"
        :label="$t('pages_merchant2_064')"
        :rules="{ required: true }"
      >
        <upload-auto
          ref="uploadSourceFundsPathRef"
          v-model:file-content="modelForm.sourceFundsPath"
          accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
          type="INVITE"
          list-type="picture"
          back-type="array"
          :disabled="modelForm.sourceFundsPathDisabled"
          :explain="$t('pages_merchant_032')"
          :max-count="5"
        />
        <div v-if="!modelForm.sourceFundsPathDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.sourceFundsPathMessage }}</span>
        </div>
      </a-form-item>

      <a-form-item style="text-align: right; margin-top: 48px">
        <a-button
          type="primary"
          shape="round"
          ghost
          style="min-width: 138px; margin-right: 24px"
          @click="$emit('next', '1-3')"
        >{{ $t('pages_merchant_040') }}</a-button>
        <a-button
          html-type="submit"
          type="primary"
          shape="round"
          style="min-width: 138px"
        >{{ $t('pages_merchant_020') }}</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import { ref, reactive, toRefs, computed, nextTick, onUnmounted } from 'vue'
import UploadAuto from '@/components/upload-auto'
import i18n from '@/locale'
export default {
  name: 'BusinessLicense',
  components: {
    'upload-auto': UploadAuto
  },
  props: {
    model: {
      type: Object,
      default: () => { return {} }
    },
    refused: {
      type: Boolean,
      default: () => { return false }
    },
    countryCode: {
      type: String,
      default: () => { return '' }
    }
  },
  setup (props, ctx) {
    const step4Ref = ref(null)
    const uploadBizRegProofPathRef = ref(null)
    const uploadCiPathRef = ref(null)
    const uploadNnc1PathRef = ref(null)
    const uploadNar1PathRef = ref(null)
    const uploadCorpConstPathRef = ref(null)
    const uploadShareCerPathRef = ref(null)
    const uploadGoodStandingPathRef = ref(null)
    const uploadRegApplyPathRef = ref(null)
    const uploadProxyProfPathRef = ref(null)
    const uploadDirectIncumPathRef = ref(null)
    const uploadSourceFundsPathRef = ref(null)

    const merchantRegistrationTypes = [
      { id: '0', name: i18n.global.t('pages_merchant2_016_0') },
      { id: '1', name: i18n.global.t('pages_merchant2_016_1') },
      { id: '2', name: i18n.global.t('pages_merchant2_016_2') },
      { id: '3', name: i18n.global.t('pages_merchant2_016_3') },
      { id: '4', name: i18n.global.t('pages_merchant2_016_4') },
      { id: '5', name: i18n.global.t('pages_merchant2_016_5') },
      { id: '6', name: i18n.global.t('pages_merchant2_016_6') },
      { id: '7', name: i18n.global.t('pages_merchant2_016_7') },
      { id: '8', name: i18n.global.t('pages_merchant2_016_8') },
      { id: '9', name: i18n.global.t('pages_merchant2_016_9') },
      { id: '10', name: i18n.global.t('pages_merchant2_016_10') },
      { id: '11', name: i18n.global.t('pages_merchant2_016_11') },
      { id: '12', name: i18n.global.t('pages_merchant2_016_12') },
      { id: '13', name: i18n.global.t('pages_merchant2_016_13') }
    ]

    const state = reactive({
    })

    state.modelForm = computed(() => {
      console.log('model:', props.model)
      return props.model
    })

    onUnmounted(() => {
      // state.modelForm.bizRegProofPath = []
      // state.modelForm.ciPath = []
      // state.modelForm.nnc1Path = []
      // state.modelForm.corpConstPath = []
      // state.modelForm.shareCerPath = []
      // state.modelForm.goodStandingPath = []
      // state.modelForm.nar1Path = []
      // state.modelForm.regApplyPath = []
      // state.modelForm.proxyProfPath = []
    })

    const submit = () => {
      ctx.emit('next', '2-2')
    }

    nextTick(() => {
      const { bizRegProofPath, ciPath, nnc1Path2, corpConstPath, shareCerPath, goodStandingPath, nar1Path2, regApplyPath, proxyProfPath, directIncumPath, sourceFundsPath } = state.modelForm

      console.log('xxx:', bizRegProofPath)

      if (bizRegProofPath && bizRegProofPath.length !== 0 && uploadBizRegProofPathRef.value) uploadBizRegProofPathRef.value.fileListRefresh(bizRegProofPath)
      if (ciPath && ciPath.length !== 0 && uploadCiPathRef.value) uploadCiPathRef.value.fileListRefresh(ciPath)
      if (nnc1Path2 && nnc1Path2.length !== 0 && uploadNnc1PathRef.value) uploadNnc1PathRef.value.fileListRefresh(nnc1Path2)
      if (corpConstPath && corpConstPath.length !== 0 && uploadCorpConstPathRef.value) uploadCorpConstPathRef.value.fileListRefresh(corpConstPath)
      if (shareCerPath && shareCerPath.length !== 0 && uploadShareCerPathRef.value) uploadShareCerPathRef.value.fileListRefresh(shareCerPath)
      if (goodStandingPath && goodStandingPath.length !== 0 && uploadGoodStandingPathRef.value) uploadGoodStandingPathRef.value.fileListRefresh(goodStandingPath)
      if (nar1Path2 && nar1Path2.length !== 0 && uploadNar1PathRef.value) uploadNar1PathRef.value.fileListRefresh(nar1Path2)
      if (regApplyPath && regApplyPath.length !== 0 && uploadRegApplyPathRef.value) uploadRegApplyPathRef.value.fileListRefresh(regApplyPath)
      if (proxyProfPath && proxyProfPath.length !== 0 && uploadProxyProfPathRef.value) uploadProxyProfPathRef.value.fileListRefresh(proxyProfPath)
      if (directIncumPath && directIncumPath.length !== 0 && uploadDirectIncumPathRef.value) uploadDirectIncumPathRef.value.fileListRefresh(directIncumPath)
      if (sourceFundsPath && sourceFundsPath.length !== 0 && uploadSourceFundsPathRef.value) uploadSourceFundsPathRef.value.fileListRefresh(sourceFundsPath)
    })

    return {
      step4Ref,
      uploadBizRegProofPathRef,
      uploadCiPathRef,
      uploadNnc1PathRef,
      uploadNar1PathRef,
      uploadCorpConstPathRef,
      uploadShareCerPathRef,
      uploadGoodStandingPathRef,
      uploadRegApplyPathRef,
      uploadProxyProfPathRef,
      uploadDirectIncumPathRef,
      uploadSourceFundsPathRef,
      merchantRegistrationTypes,
      submit,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less" scoped>
#businessLicense {
  .material-business-license {
    .explain {
      color: #495060;
    }
  }
}

</style>

